import React from 'react'
import { motion } from 'framer-motion';

function Progressbar() {
  return (
    <div className="container my-5 d-flex justify-content-center">
        
            <motion.div
                className="card shadow-lg"
                style={{ width: '38rem', overflow: 'hidden', background: 'None' }}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.6, ease: 'easeOut' }}
            >
            <div class="card-body">
                <h2 class="card-title my-4 text-danger">Important Dates </h2>
                
                <h5 class="card-title">Full Paper Submission Last Date: </h5>
                <p className="card-text"><span className="text-danger"> <strong>30<sup>th</sup> May, 2026 (Hard Deadline)</strong></span> </p>
                <h5 class="card-title">Notification for Paper Acceptance: </h5>
                <p className="card-text"> <del>15<sup>th</sup> July, 2026</del> <span className="text-danger"> <strong>20<sup>th</sup> July, 2026 (In Pipeline)</strong></span></p>
                {/* <h5 class="card-title">Early Bird Registration: </h5>
                <p className="card-text">15<sup>th</sup> May, 2026</p> */}
                <h5 class="card-title">Author's Registration Deadline: </h5>
                <p className="card-text"> <del>30<sup>th</sup> June, 2026</del> 30<sup>th</sup> July, 2026</p>
                <h5 class="card-title">Camera Ready Submission: </h5>
                <p className="card-text"><del>30<sup>th</sup> June, 2026</del> 30<sup>th</sup> July, 2026</p>
                <h5 class="card-title">Attendees/Poster Presenter Registration Deadline: </h5>
                <p className="card-text">30<sup>th</sup> July, 2026</p>
                <h5 class="card-title">Information for Conference Schedule:</h5>
                <p className="card-text">08<sup>th</sup> September, 2026</p>
                <h5 class="card-title text-danger">Conference Date: </h5>
                <p className="card-text">08<sup>th</sup> October, 2026 - 10<sup>th</sup> October, 2026</p>
            </div>
            </motion.div>
        
    </div>
  )
}

export default Progressbar